const getInitials = (name) => {
    if (!name)
        return '';
    return name
        .trim()
        .split(/\s+/)
        .map((word) => { var _a; return ((_a = word[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || ''; })
        .join('');
};
export default getInitials;
